/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ZoomRegular from './zoom-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ZoomRegular {...validProps} />;
}
SvgComponent.iconName = 'zoomRegular';

export const ZoomRegularIcon = svgIconWrapper(SvgComponent);
